{
	"pixKeyLabel": "PIX Key",
	"pixTypeLabel": "PIX Key Type",
	"pixTypePlaceholder": "Select the PIX Key Type",
	"defaultPlaceholder": "Enter PIX key",
	"copyPastePlaceholder": "Paste your PIX key",
	"placeholders": {
		"phone": "(41) 99999-9999",
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "example@email.com",
		"evp": "Random key"
	},
	"pixKeyType": {
		"random": "Random",
		"phone": "Phone",
		"copyPaste": "Copy and Paste"
	},
	"validation": {
		"invalidPixKey": "Invalid PIX key"
	}
}
